import { Outlet } from 'react-router-dom';
import FonemedLogo from "../assets/images/FoneMed-Logo.jpg";
import Verify from '../components/Verify';
import SetPassword from '../components/ResetPassword/SetPassword';
import ForgotPassword from '../components/ForgetPassword/forgot-password';
import ResetPassword from '../components/ResetPassword/ResetPassword';
import VerifiedUserSetPass from '../components/ResetPassword/VerifiedUserSetPass';
import AccountSetup from '../components/Admin/IDP/AccountSetup';

export const AuthAppLayout = ({ children }) => {
    return (
        <section className="login-wrapper">
            <div className="left-wrap"></div>
            <div className="right-wrap">
                <div className="form-wrap">
                    <a href="#as" className="logo" title="Fonemed A Healthier Tomorrow">
                        <img src={FonemedLogo} alt="Fonemed A Healthier Tomorrow" />
                    </a>
                    {children}
                    <Outlet />
                </div>
            </div>
        </section>
    );
};


export const SAMLAuthLayout = ({ children }) => {
    return (
        <section style={{ minHeight: "100vh", display: "flex" }}>
            {/* Sidebar */}
            <div style={{
                width: "80px",
                backgroundColor: "#005da8",
                flexShrink: 0,
            }}>
                {/* Sidebar is empty blue area for now */}
            </div>

            {/* Main Area */}
            <div style={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
                {/* Header */}
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem 2rem",
                    backgroundColor: "#f5f5f5",
                    borderBottom: "1px solid #ddd",
                }}>
                    <img
                        src={FonemedLogo}
                        alt="Fonemed Logo"
                        style={{
                            height: "40px",
                            marginRight: "1rem",
                        }}
                    />
                    <h4 style={{ margin: 0, fontSize: "1.5rem", fontWeight: "500", color: "#333" }}>
                        Please complete your profile
                    </h4>
                </div>

                {/* Page Content */}
                <div style={{ flexGrow: 1, padding: "2rem" }}>
                    {children}
                    <Outlet />
                </div>
            </div>
        </section>
    );
};


export const publicRoutes = [
    {
        path: '/auth',
        element: <AuthAppLayout />,
        children: [
            { path: 'setpassword', element: <SetPassword /> },
            { path: 'verifiedUserSetPass', element: <VerifiedUserSetPass /> },
            { path: 'verifyMFA', element: <Verify /> },
            { path: 'forgotpassword', element: <ForgotPassword isExpired={false} /> },
            { path: 'resetpassword', element: <ResetPassword /> },
            { path: 'reset-temporary-pass', element: <ForgotPassword isExpired={true} /> },
            //{ path: '*', element: <Navigate to="/" /> },
        ],
    },
];

export const SAMLRoutes = [
    {
        path: '/saml',
        element: <SAMLAuthLayout />,
        children: [
            { path: 'account-setup', element: <AccountSetup /> }
        ],
    },
];
